var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.$data.$_enableCarousel
    ? _c(
        "a",
        {
          staticClass: "owl-carousel owl-theme",
          attrs: {
            id: "owl-carousel-" + _vm._uid,
            href: _vm.itemUrl,
            role: "listbox",
            "aria-label": _vm.$translate("Ceres::Template.itemImageCarousel")
          }
        },
        _vm._l(_vm.imageUrls, function(imageUrl, index) {
          return _c(
            "div",
            { key: index },
            [
              index === 0 && !_vm.disableLazyLoad
                ? _c("lazy-img", {
                    ref: "itemLazyImage",
                    refInFor: true,
                    attrs: {
                      "picture-class": "img-fluid",
                      "image-url": imageUrl.url,
                      alt: _vm.getAltText(imageUrl),
                      title: _vm.getTitleText(imageUrl),
                      role: "option"
                    }
                  })
                : index !== 0 && !_vm.disableLazyLoad
                ? _c("img", {
                    staticClass: "img-fluid owl-lazy",
                    attrs: {
                      "data-src": imageUrl.url,
                      alt: _vm.getAltText(imageUrl),
                      title: _vm.getTitleText(imageUrl),
                      role: "option"
                    }
                  })
                : _c("img", {
                    staticClass: "img-fluid",
                    attrs: {
                      src: imageUrl.url,
                      alt: _vm.getAltText(imageUrl),
                      title: _vm.getAltText(imageUrl),
                      role: "option"
                    }
                  })
            ],
            1
          )
        }),
        0
      )
    : _c(
        "a",
        { attrs: { href: _vm.itemUrl, "aria-label": "item link" } },
        [
          !_vm.disableLazyLoad
            ? _c("lazy-img", {
                ref: "itemLazyImage",
                attrs: {
                  "picture-class": "img-fluid",
                  "image-url": _vm._f("itemImage")(_vm.imageUrls),
                  alt: _vm.getAltText(_vm.imageUrls[0]),
                  title: _vm.getTitleText(_vm.imageUrls[0])
                }
              })
            : _c("img", {
                staticClass: "img-fluid",
                attrs: {
                  src: _vm._f("itemImage")(_vm.imageUrls),
                  alt: _vm.getAltText(_vm.imageUrls[0]),
                  title: _vm.getTitleText(_vm.imageUrls[0])
                }
              })
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }